import axios, { AxiosResponse } from 'axios';
import { AxiosRequestConfig } from "axios/index";
import { toast } from 'react-toastify';
import { CODES } from "../constants";
import { S4PRespBody } from "./types";
import Loader from '../components/Loading/index'

// let HOST = 'http://192.168.31.200:8003'
let HOST = ''

if (process.env.NODE_ENV === 'production') {
  HOST = ''
}

export default (uri: string, params: any): Promise<S4PRespBody> => {
  let config: AxiosRequestConfig = {
    baseURL: HOST,
    headers: {
      Accept: 'application/json',
      location: uri,
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Requested-With': 'H5-Qilinjinfu',
      'X-Client-Version': '1.0'
    },
    withCredentials: true,
    responseType: 'blob'
  }
  let _params = {
    body: params,
    sign: ''
  }

  let closeLoader = Loader.open({ content: '正在加载...' })
  return axios.post(uri, _params, config)
    .then(function (response: AxiosResponse<Blob>) {

      let url = window.URL.createObjectURL(response.data);
      console.log(url)
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = 'export.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

      return {
        code: CODES.SUCCESS,
        msg: ''
      }
    })
    .catch(function (error) {
      console.log(error);
      toast.error('系统繁忙，请稍后再试');
      return {
        code: CODES.SYS_ERROR,
        msg: error
      }
    }).finally(() => {
      closeLoader()
    });
}